import { DtoState } from '@marketplace-web/catalog/catalog-data'

import { DtoAction, DtoReducerAction } from './actionTypes'

export const dtoReducer = (state: DtoState, action: DtoAction): DtoState => {
  switch (action.type) {
    case DtoReducerAction.CHANGE_DTO: {
      return { ...state, ...action.payload.dtos }
    }
    default:
      return state
  }
}
